var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddresses = function SvgAddresses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 5343"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5908"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5558",
    transform: "translate(-1066.401 -577.119)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 5063"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M1078.502 582.837h6.769l5.13 5.467v7.143h-11.9Zm6.153 1.362h-4.968v9.886h9.316v-5.252Z",
    "data-name": "Path 5065"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 3.158,
    cy: 3.158,
    r: 3.158,
    fill: "#fff",
    "data-name": "Ellipse 810",
    transform: "translate(1081.116 591.597)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M1084.451 590.847a3.908 3.908 0 1 1-3.908 3.908 3.913 3.913 0 0 1 3.908-3.908m0 6.317a2.408 2.408 0 1 0-2.408-2.409 2.41 2.41 0 0 0 2.408 2.409",
    "data-name": "Ellipse 810 - Outline"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5205"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M1066.401 580.119h13.332v15.35h-13.332Zm11.839 1.35h-10.454v12.643h10.454Z",
    "data-name": "Rectangle 5206"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 3.158,
    cy: 3.158,
    r: 3.158,
    fill: "#fff",
    "data-name": "Ellipse 809",
    transform: "translate(1069.196 591.597)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M1072.562 590.847a3.908 3.908 0 1 1-3.908 3.908 3.913 3.913 0 0 1 3.908-3.908m0 6.317a2.408 2.408 0 1 0-2.408-2.409 2.41 2.41 0 0 0 2.408 2.409",
    "data-name": "Ellipse 809 - Outline"
  })))));
};
export default SvgAddresses;